<template>
    <div class="page-wrapper">
      <Loader :active="isLoading" message="অনুগ্রহ করে অপেক্ষা করুন..." />
      
      <Navbar />
      
      <div class="container py-5">
        <div class="row justify-content-center">
          <div class="col-xl-10 col-lg-11">
            <div class="card border-0 shadow-lg rounded-3 overflow-hidden">
              <div class="row g-0">
                
                <div class="col-lg-4 d-none d-lg-block bg-primary-gradient d-flex align-items-center justify-content-center p-5">
                   <div class="text-center text-white">
                      <img src="https://image.ibb.co/kUagtU/rocket_contact.png" alt="rocket" class="rocket-img mb-4"/>
                      <h3 class="font-weight-bold">আপনার অভিযোগ জানান</h3>
                      <p class="opacity-75">অনুগ্রহ করে নিচের ফর্মে সমস্যার বিবরণ পূরণ করুন।</p>
                   </div>
                </div>
  
                <div class="col-lg-8 bg-white">
                  <div class="card-body p-4 p-md-5">
                    <div class="alert alert-light border mb-4">
                      <small class="text-muted d-block uppercase">ডিভাইস: </small>
                      <h5 class="mb-0 font-weight-bold text-dark">
                          {{ localDevice ? localDevice.name : 'কোনো ডিভাইস নির্বাচন করা হয়নি' }}
                      </h5>
                    </div>
  
                    <form @submit.prevent="onClickLog">
                      <div class="row">
                          <div class="col-md-6 mb-3">
                            <label class="form-label text-muted small">অভিযোগের বিবরণ</label>
                            
                            <div class="form-group mb-3">
                              <v-select 
                                v-model="complainNature" 
                                :options="natureOptions" 
                                label="label" 
                                placeholder="অভিযোগের ধরন নির্বাচন করুন *" 
                                class="style-chooser"
                              >
                                <template #option="{ label }"><div class="text-wrap-option">{{ label }}</div></template>
                                <template #no-options>কিছু খুঁজে পাওয়া যায়নি</template>
                              </v-select>
                            </div>
  
                            <div class="form-group mb-3">
                              <v-select 
                                v-model="complainClass" 
                                :options="classOptions" 
                                label="label"
                                placeholder="গুরুত্ব নির্বাচন করুন *" 
                                class="style-chooser"
                              >
                              </v-select>
                            </div>
                          </div>
  
                          <div class="col-md-6 mb-3">
                            <label class="form-label text-muted small">বর্ণনা</label>
                            <textarea 
                              v-model="complainDescription" 
                              class="form-control" 
                              placeholder="সমস্যাটি বিস্তারিত লিখুন..." 
                              style="height: 125px;" 
                              required
                            ></textarea>
                          </div>
  
                          <div class="col-12 mb-4">
                             <div class="file-upload-wrapper p-3 border rounded bg-light">
                                <label class="small text-muted mb-2">ফাইল সংযুক্ত করুন (ঐচ্ছিক)</label>
                                <input type="file" class="form-control-file" ref="file" @change="handleFileUpload" accept="image/*" />
                             </div>
                          </div>
  
                          <div class="col-12">
                            <button type="submit" :disabled="isLoading" class="btn btn-primary btn-lg w-100 shadow-sm">
                              অভিযোগ জমা দিন
                            </button>
                          </div>
                      </div>
                    </form>
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="showModal" class="modal-backdrop fade show"></div>
      <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content border-0 shadow">
            <div class="modal-header" :class="isSuccess ? 'bg-success text-white' : 'bg-danger text-white'">
              <h5 class="modal-title font-weight-bold">{{ modalTitle }}</h5>
              <button type="button" class="close text-white" @click="closeModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body py-4">
              <div class="text-center">
                 <div v-if="isSuccess" class="mb-3">
                    <b-icon icon="check-circle-fill" variant="success" font-scale="4"></b-icon>
                 </div>
                 <div v-else class="mb-3">
                    <b-icon icon="exclamation-circle-fill" variant="danger" font-scale="4"></b-icon>
                 </div>
                 <p class="h5 text-secondary">{{ modalMessage }}</p>
              </div>
            </div>
            <div class="modal-footer justify-content-center bg-light">
              <button type="button" class="btn" :class="isSuccess ? 'btn-success' : 'btn-danger'" @click="closeModal">
                {{ isSuccess ? 'ঠিক আছে' : 'বন্ধ করুন' }}
              </button>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import Navbar from './components/Navbar.vue';
  import Loader from './components/Loader.vue';
  import { getAPI } from './axios-api.js'
  import vSelect from 'vue-select' 
  import 'vue-select/dist/vue-select.css'
  import { logServerError } from './utils/logger.js'; // Import logger 
  
  export default {
      name: 'Complain',
      components: { Navbar, vSelect, Loader },
      data() {
          return {
              localDevice: null,
              complainNature: null,
              complainClass: null,
              complainDescription: '',
              proofFile: null,
              isLoading: false,
              showModal: false,
              modalTitle: '',
              modalMessage: '',
              isSuccess: false,
  
              // Translated Labels but kept English Values for Backend
              natureOptions: [
                  { label: 'ইনভেন্টরি মিসম্যাচ ইস্যু (Inventory Mismatch)', value: 'Inventory Mismatch Issue' },
                  { label: 'চালান সংক্রান্ত ইস্যু (Challan Issue)', value: 'Challan Related Issue' },
                  { label: 'ড্রপ সেন্সর ইস্যু (Drop Sensor)', value: 'Device Drop Sensor Issue' },
                  { label: 'মোটর ইস্যু (Motor)', value: 'Device Motor Issue' },
                  { label: 'আরএফআইডি রিডার ইস্যু (RFID Reader)', value: 'RFID Reader Issue' },
                  { label: 'নেটওয়ার্ক ইস্যু (Network)', value: 'Network Issue' },
                  { label: 'মডেম ইস্যু (Modem)', value: 'Modem Issue' },
                  { label: 'প্রোডাক্ট এর ইস্যু (Product Issue)', value: 'Product Issue' },
                  { label: 'কার্ড সংক্রান্ত ইস্যু (User Card)', value: 'User Card Related Issue' },
                  { label: 'কার্ড রেজিস্ট্রেশন ইস্যু (Registration)', value: 'User Card Registration Issue' },
                  { label: 'ইউজার এর লিমিট ইস্যু (User Limit)', value: 'User Limit Issue' },
                  { label: 'এজেন্ট ইস্যু (Agent)', value: 'Agent Issue' },
                  { label: 'পেমেন্ট ইস্যু (Payment)', value: 'Payment Issue' },
                  // নতুন যুক্ত করা অপশনসমূহ
                  { label: 'সার্কিটের ইস্যু (Main PCB)', value: 'Main PCB Issue' },
                  { label: 'SMPS ইস্যু (Power supply)', value: 'SMPS Problem' },
                  { label: 'ড্রপ সেন্সর PCB ইস্যু', value: 'Drop Sensor PCB Problem' },
                  { label: 'Nodemcu ইস্যু ( RFID/Motor)', value: 'Nodemcu Problem' },
                  { label: 'স্প্রিংয়ের বুশের ইস্যু', value: 'Spring Bush Issue' },
                  { label: 'স্প্রিং টাল', value: 'Spring Bend Issue' },
                  { label: 'চার্জার এডাপ্টার নষ্ট', value: 'Charger Adapter Damaged' },
                  { label: 'GSM ইস্যু', value: 'GSM Problem' },
                  { label: 'P-Holder ভাঙ্গা', value: 'Broken P-Holder' },
                  { label: 'পাওয়ার কানেকশন জনিত ইস্যু', value: 'Power Connection Issue' },
                  
                  { label: 'অন্যান্য (Others)', value: 'Others' }
              ],
  
              // Translated Class Options
              classOptions: [
                  { label: 'সাধারণ (General)', value: 'General' },
                  { label: 'জরুরি (Emergency)', value: 'Emergency' }
              ]
          }
      },
      
      created() {
          if (this.$route.params.deviceData) {
              this.localDevice = this.$route.params.deviceData;
          } else {
              // Translated Alert
              alert("ডিভাইসের তথ্য পাওয়া যাচ্ছে না। অনুগ্রহ করে তালিকা থেকে ডিভাইস নির্বাচন করুন।");
              this.$router.push({ name: 'posts' }); 
          }
      },
      
      methods: {
          handleFileUpload(event) {
            this.proofFile = event.target.files[0];
          },
  
          async onClickLog() {
              if(!this.localDevice || !this.localDevice.name) {
                  alert("ডিভাইসের তথ্য পাওয়া যাচ্ছে না।");
                  return;
              }
              if(!this.complainNature || !this.complainClass) {
                  alert("অনুগ্রহ করে অভিযোগের ধরন এবং গুরুত্ব নির্বাচন করুন।");
                  return;
              }
  
              this.isLoading = true;
  
              var formData = new FormData();
              formData.append('device_Name', this.localDevice.name)
              
              // IMPORTANT: Sending .value (English) to backend, while user sees .label (Bengali)
              formData.append('Complain_Nature', this.complainNature.value)
              formData.append('Complain_Class', this.complainClass.value)
              
              formData.append('Complain_Summary', this.complainDescription)
              
              if(this.proofFile) {
                formData.append('proof_File', this.proofFile);
              }
  
              try {
                  await getAPI.post('/complainLog/', formData, {
                      headers: {
                          'Content-Type': 'multipart/form-data',
                          Authorization: `Bearer ${localStorage.getItem('access_token')}`
                      }
                  })
                  
                  this.isSuccess = true;
                  this.modalTitle = 'সফল'; // Success
                  this.modalMessage = 'আপনার অভিযোগটি জমা দেওয়া হয়েছে।';
                  this.showModal = true;
  
              } catch (error) {
                  console.error(error)
                  await logServerError(error);
                  this.isSuccess = false;
                  this.modalTitle = 'ত্রুটি'; // Error
                  this.modalMessage = 'অভিযোগ জমা দেওয়া যায়নি। অনুগ্রহ করে ইন্টারনেট সংযোগ পরীক্ষা করুন।';
                  this.showModal = true;
              } finally {
                  this.isLoading = false;
              }
          },
  
          closeModal() {
              this.showModal = false;
              if (this.isSuccess) {
                  this.$router.push('/ComplainStatus');
              }
          }
      }
  }
  </script>
  
  <style scoped>
    /* ... Existing CSS ... */
    .page-wrapper {
      min-height: 100vh;
      background: #f0f2f5;
      background: linear-gradient(135deg, #f0f2f5 0%, #e1e4e8 100%);
    }
    .bg-primary-gradient {
      background: linear-gradient(180deg, #0062cc 0%, #00c6ff 100%);
    }
    .rocket-img {
      width: 120px;
      animation: float 3s ease-in-out infinite;
    }
    @keyframes float {
      0% { transform: translateY(0px) rotate(29deg); }
      50% { transform: translateY(-15px) rotate(29deg); }
      100% { transform: translateY(0px) rotate(29deg); }
    }
    .form-control, .form-select {
      border-radius: 8px;
      border: 1px solid #ced4da;
      padding: 10px 15px;
      font-size: 0.95rem;
    }
    .form-control:focus, .form-select:focus {
      box-shadow: 0 0 0 3px rgba(0, 98, 204, 0.15);
      border-color: #0062cc;
    }
    textarea { resize: vertical; }
    .btn-primary {
      background-color: #0062cc;
      border: none;
      padding: 12px;
      font-weight: 600;
      letter-spacing: 0.5px;
      border-radius: 8px;
    }
    .modal-backdrop { opacity: 0.5; }
    .modal.show { background: rgba(0,0,0,0.5); }
    .file-upload-wrapper {
        background-color: #f8f9fa;
        border: 1px dashed #ced4da !important;
    }
    @media (max-width: 768px) {
      .card-body { padding: 1.5rem !important; }
    }
  </style>